import channel from '@/channel'
import _ from 'lodash'
const throttleTriggerErrorNotification = _.throttle(channel.triggerErrorNotification, 3000, {
  'leading': true,
  'trailing': false
})
export default store => {
  // called when the store is initialized
  store.subscribe((mutation) => {
    // called after every mutation
    // The mutation comes in the format of `{ type, payload }`.
    if (mutation.type.startsWith('report/')) {
      const errors = store.getters['report/errors'].slice(0) // shallow clone
      const managerId = store.getters['report/managerId']
      errors.forEach(error => {
        throttleTriggerErrorNotification(error, managerId)
        store.dispatch('report/removeError', error)
      })
    }
  })
}
